// extracted by mini-css-extract-plugin
module.exports = {"menu":"Dropdown_menu__eTA9l","dropdown":"Dropdown_dropdown__bI_vu"};